import { useLanguage } from '../i18n/LanguageProvider';
import { languages } from '../i18n/translations';

const LABELS: Record<string, string> = { sv: 'SV', en: 'EN' };

export default function LanguageToggle() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="lang-toggle" role="group" aria-label={t.a11y.language}>
      {languages.map((code) => (
        <button
          key={code}
          type="button"
          lang={code}
          className={language === code ? 'is-active' : undefined}
          aria-pressed={language === code}
          onClick={() => setLanguage(code)}
        >
          {LABELS[code]}
        </button>
      ))}
    </div>
  );
}
